module.exports = __webpack_public_path__ + "static/media/winterweave-2.1ed68c55.jpg";